@if (!showPlansPage) {
  <div class="container">
    <div class="back pointer" (click)="back()">
      <img src="/assets/img/icons/chevron-back.svg" alt="chevron-back" />
      <p class="body-14-bold">{{ 'LATER' | translate }}</p>
    </div>

    @switch (popupId) {
      @case ('FTR-STAKING-V1') {
        @defer {
          <app-early-access-feature-dialog class="popup width-587"></app-early-access-feature-dialog>
        }
      }

      @case ('FTR-BALANCE-V2') {
        @defer {
          <app-new-features-dialog class="popup width-534" (closeDialog)="back()"></app-new-features-dialog>
        }
      }

      @case ('MKT-ADDONS-V1') {
        @defer {
          <app-addons-dialog class="popup width-837"></app-addons-dialog>
        }
      }

      @case ('REF-FRIEND-INVITE-2025') {
        @defer {
          <app-referral-dialog class="popup width-512"></app-referral-dialog>
        }
      }

      @case ('MKT-MOBILEAPP-V1') {
        @defer {
          <app-download-app-dialog
            class="popup width-471"
            [userPreferences]="userPreferences"
            (closeDialog)="back()"
          ></app-download-app-dialog>
        }
      }

      @case ('MKT-ENDZONE-2025-BE') {
        @defer {
          <app-tax-season-end-dialog
            class="popup tax-season-end-dialog"
            [popupId]="popupId"
          ></app-tax-season-end-dialog>
        }
      }

      @case ('MKT-ENDZONE-2025-ES') {
        @defer {
          <app-tax-season-end-dialog
            class="popup tax-season-end-dialog"
            [popupId]="popupId"
          ></app-tax-season-end-dialog>
        }
      }

      @case ('MKT-ENDZONE1-2025-FR') {
        @defer {
          <app-tax-season-end-dialog
            class="popup tax-season-end-dialog"
            [popupId]="popupId"
          ></app-tax-season-end-dialog>
        }
      }

      @case ('MKT-ENDZONE2-2025-FR') {
        @defer {
          <app-tax-season-end-dialog
            class="popup tax-season-end-dialog"
            [popupId]="popupId"
          ></app-tax-season-end-dialog>
        }
      }

      @case ('MKT-ENDZONE3-2025-FR') {
        @defer {
          <app-tax-season-end-dialog
            class="popup tax-season-end-dialog"
            [popupId]="popupId"
          ></app-tax-season-end-dialog>
        }
      }
    }
  </div>
} @else {
  @defer {
    <app-plans-page [popupId]="popupId" [voucher]="voucher" (back)="closePlansPage()"></app-plans-page>
  }
}
